/**
 * Combine all API configurations in this file and export the concatenated configurations.
 * Also add some shared state to all of them.
 */
import suggestionApiConfiguration from './suggestionApiConfiguration';
import taxonomyApiConfiguration from './taxonomyApiConfiguration';
import proximityApiV2Configuration from './proximityApiV2Configuration';
import aggregatesV2ApiConfiguration from './aggregatesApiV2Configuration';
import containsApiV2Configuration from './containsApiV2Configuration';
import searchApiV2Configuration from './searchApiV2Configuration';
import aggregatesApiV3GetConfiguration from './aggregatesApiV3GetConfiguration';

const defaults = {
	totalResults: 0,
	timeTaken: 0,
	error: null,
	loading: false,
	results: null,
};

export default [
	{ ...suggestionApiConfiguration, ...defaults },
	{ ...taxonomyApiConfiguration, ...defaults },
	{ ...proximityApiV2Configuration, ...defaults },
	{ ...aggregatesV2ApiConfiguration, ...defaults },
	{ ...containsApiV2Configuration, ...defaults },
	{ ...searchApiV2Configuration, ...defaults },
	{ ...aggregatesApiV3GetConfiguration, ...defaults },
];
